"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Header350DefaultProps = exports.Header350 = void 0;
var _header = _interopRequireDefault(require("./components/header-350"));
exports.Header350 = _header["default"];
var _header2 = _interopRequireDefault(require("./components/header-350.props/header-350.defaultProps"));
exports.Header350DefaultProps = _header2["default"];